import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import { CampaignAdgroupSelector } from './index';

const CAMPAIGN_PAGESIZE = 10;
const ADGROUP_PAGESIZE = 6;

/**
 * the backbone view for the react campaign adgroup selector
 * campaign format: {onFetch, pageSize}
 * adgroup format: {onFetch, pageSize}
 */
export class CampaignAdgroupSelectorView extends Backbone.View {
  initialize({
    i18n, campaign, adgroup, selectedCampaign, selectedAdGroup,
    isMultiMode, onSelectDone, stringKeys,
  }) {
    this.i18n = i18n;
    this.campaign = campaign;
    this.selectedCampaign = selectedCampaign;
    this.campaign.onSelect = this.onCampaignSelected.bind(this);
    if (!campaign.pageSize) {
      this.campaign.pageSize = CAMPAIGN_PAGESIZE;
    }
    this.adgroup = adgroup;
    this.selectedAdGroup = selectedAdGroup;
    this.adgroup.onSelect = this.onAdgroupSelected.bind(this);
    if (!adgroup.pageSize) {
      this.adgroup.pageSize = ADGROUP_PAGESIZE;
    }
    this.isMultiMode = isMultiMode;
    this.adgroupSelectDone = onSelectDone;
    this.onSelectDone = this.onSelectDone.bind(this);
    this.stringKeys = stringKeys;
  }

  /**
   * should trigger event to notify outter component
   * @param {object} selectedItem - the item selected
   * @returns {undefined} update the state with fetch result
   */
  onCampaignSelected(selectedItem) {
    this.trigger('selected-campaign', selectedItem);
  }

  /**
   * should trigger event to notify outter component
   * @param {object} selectedItem - the item selected
   * @returns {undefined} update the state with fetch result
   */
  onAdgroupSelected(selectedItem) {
    this.trigger('selected-adgroup', selectedItem);
  }

  onSelectDone(selectedList) {
    if (this.adgroupSelectDone) {
      this.adgroupSelectDone(selectedList);
    }
    this.trigger('selected-adgroup-list', selectedList);
  }

  render() {
    ReactDOM.render(
      (
        <CampaignAdgroupSelector
          i18n={this.i18n}
          campaign={this.campaign}
          adgroup={this.adgroup}
          selectedAdGroup={this.selectedAdGroup}
          selectedCampaign={this.selectedCampaign}
          onSelectDone={this.onSelectDone}
          isMultiMode={this.isMultiMode}
          stringKeys={this.stringKeys}
        />
      ), this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
